module.exports = __webpack_public_path__ + "img/77404.118918b8.svg";